import { ReactComponent as SuperscriptIcon } from 'assets/icons/superscript16.svg'
import { useSuperscriptToggle } from 'common/Prose/Toolbar/hooks/useSuperscriptToggle'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const SuperscriptInlineFormatButton = observer(function SuperscriptInlineFormatButton({
  view,
  callback,
}: {
  view: EditorView
  callback?: () => void
}) {
  const { active, disabled, handleClick } = useSuperscriptToggle(view)

  return (
    <InlineFormatDropdownMenuItem
      key={'superscript'}
      onClick={() => {
        handleClick()
        callback?.()
      }}
      active={active}
      isDisabled={disabled}
      icon={<SuperscriptIcon />}
      label="Superscript"
    />
  )
})
